import React from "react";
import { useState, useEffect } from "react";
import { AiOutlineSearch, AiOutlinePlus } from "react-icons/ai";
import "./CountrySelector.css";

const CountrySelector = (props) => {
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [searchText, setSearchText] = useState();

  // Effect that runs to filter the countries down to the available countries in the list
  // Runs every time the unique countries, the search text or the selected country changes
  useEffect(() => {
    let availableCountries = props.uniqueCountries.filter((country) => {
      return country !== props.selectedCountry;
    });
    let searchFilterCuntries = availableCountries.filter((country) => {
      return (
        country
          .toLowerCase()
          .replace(/\u00fc/g, "u")
          .search(searchText) !== -1
      );
    });

    setFilteredCountries(searchFilterCuntries);
  }, [props.uniqueCountries, searchText, props.selectedCountry]);

  const handleInputChange = (event) => {
    let value = event.target.value.toLowerCase().replace(/\u00fc/g, "u");
    setSearchText(value);
  };

  const handleAvailableClick = (event) => {
    props.setSelectedCountry(event.target.innerText);
  };

  const handleCompareClick = () => {
    props.setComparisonState("on");
  };

  return (
    <div className="country-selector">
      <div className="country-selector__display--selected">
        <div className="list-item--selected-single">
          {props.selectedCountry}
        </div>
      </div>
      <button className="compare-button" onClick={handleCompareClick}>
        <AiOutlinePlus size={16} />
        <div className="compare-button__text">Compare with...</div>
      </button>
      <div className="country-selector__search">
        <AiOutlineSearch className="AiOutlineSearch-symbol" color={"#212b57"} />
        <input
          className="country-selector__search-input"
          type="text"
          onChange={(event) => handleInputChange(event)}
          placeholder="Search states/provinces"
        ></input>
      </div>

      <div className="country-selector__display">
        <div className="country-selector__display--available">
          {filteredCountries.map((country) => {
            return (
              <div
                className="list-item"
                key={country}
                onClick={(event) => handleAvailableClick(event)}
              >
                {country}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(CountrySelector);
